import { Link, Outlet, useLocation, useSearchParams } from 'react-router-dom'
import { SITE } from '@/lib/site'
import { RouteSeoFallback } from '@/components/RouteSeoFallback'
import { cn } from '@/lib/utils'

const NAV = [
  { label: 'All Courses', path: '/premiumcourselist', params: { id: '1' } },
  { label: 'My Purchase Plan', path: '/premium_benefit' },
  { label: 'Transaction History', path: '/purchase_history' },
] as const

/**
 * Mobile WebView layout for digital course pages (premium_benefit, premiumcourselist).
 * Mirrors legacy courseheader with logo + top nav links.
 */
export function CourseWebViewLayout() {
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const userId = searchParams.get('user_id') ?? '0'

  const withUser = (path: string, extra?: Record<string, string>) => {
    const params = new URLSearchParams({ user_id: userId, ...extra })
    return `${path}?${params.toString()}`
  }

  return (
    <div className="min-h-screen bg-[#f5f5f5]">
      <RouteSeoFallback />
      <header className="border-b border-neutral-200 bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-center px-4 py-4">
          <img src={SITE.logoSmall} alt={SITE.name} className="h-12 w-auto object-contain sm:h-14" />
        </div>
        <nav className="border-t border-neutral-100">
          <ul className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-1 px-2 py-2 text-sm sm:gap-4">
            {NAV.map((item) => {
              const href = withUser(item.path, 'params' in item ? item.params : undefined)
              const active = pathname === item.path

              return (
                <li key={item.path}>
                  <Link
                    to={href}
                    className={cn(
                      'block rounded-md px-3 py-2 font-semibold transition-colors',
                      active ? 'text-[#0f5d9a]' : 'text-neutral-700 hover:text-[#0f5d9a]',
                    )}
                  >
                    {item.label}
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>
      </header>
      <main className="mx-auto max-w-5xl px-3 py-6 sm:px-4">
        <Outlet />
      </main>
    </div>
  )
}
